import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/instantAccess';
export function InstantAccessSection() {
  return <section aria-labelledby="instant-title" className="bg-brand-cream px-4 py-20 md:py-28" data-id="element-124" data-mp="1mfc73cshcw5p">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-125" data-mp="1hnkc8q2ak49r">
        <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-126" data-mp="1hlzgwy85khau">ACCESSO IMMEDIATO</p>
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-brand-yellow text-brand-primary" data-id="element-127" data-mp="1weta1mgckvxz">
          <ZapIcon className="h-7 w-7" aria-hidden="true" data-id="element-128" data-mp="25e6gs7d376f0" />
        </div>
        <h2 id="instant-title" className="mb-12 text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-129" data-mp="20ek6o6sk26af">
          ⚡ Cosa Ottieni Subito?
        </h2>
        <ul className="space-y-3 text-left" data-id="element-130" data-mp="azvv27rsgsdg">
          {instantAccessItems.map(item => <li key={item} className="flex items-center gap-4 rounded-[18px] border border-brand-sand bg-brand-alt p-5" data-id="element-131" data-mp="623tsn597twl">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white" data-id="element-132" data-mp="2s08cdlh43u8m">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="2wz2x4syn3svd" />
              </span>
              <span className="text-sm font-semibold leading-snug md:text-base" data-id="element-134" data-mp="31rmlmkyv88ey">{item}</span>
            </li>)}
        </ul>
        <p className="mt-10 font-display text-2xl font-bold italic text-brand-accent" data-id="element-135" data-mp="35rwrzyqkl0uc">
          Non rimarrai mai più senza materiale.
        </p>
      </Reveal>
    </section>;
}